import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
 
function Team() {
  return (
    <>
      <Header />
      <main>
        <div
          className="inner-hero"
          style={{ backgroundImage: "url(/assets/img/bg/Ashok Nanda Website 1.jpg)" }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-8 m-auto text-center">
                <div className="inner-main-heading">
                  <h1>Our Team Member</h1>
                  <div className="breadcrumbs-pages">
                    <ul>
                      <li><a href="/">Home</a></li>
                      <li className="angle"><i className="fa-solid fa-angle-right" /></li>
                      <li>Our Team Member</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
 
        {/* TEAM SECTION */}
        <div className="team2 sp">
          <div className="container">
            <div className="row">
 
              {/* CARD COMPONENT REUSED */}
              {[
                { img: "team2-image1.png", name: "Rodger Struck", role: "Social Media Specialist" },
                { img: "team2-image2.png", name: "Alex Buckmaster", role: "Marketing Officer" },
                { img: "team2-image3.png", name: "Sarah Joe", role: "Marketer" },
                { img: "team2-image4.png", name: "Chris Glasser", role: "Marketer" },
                // add the rest here...
              ].map((item, index) => (
                <div
                  className="col-lg-3 col-md-6"
                  data-aos="fade-up"
                  data-aos-duration={900}
                  data-aos-delay={200 + index * 100}
                  key={index}
                >
                  <div className="team-page-item mt-30">
                    <div className="team-image-area">
                      <div className="image">
                        <img src={`/assets/img/team/${item.img}`} alt={item.name} />
                      </div>
                      <div className="shape round-circle">
                        <img src="/assets/img/shapes/team-page-item-s-shape.png" alt="" />
                      </div>
                      <div className="social-icons">
                        <ul>
                          <li><a><i className="fa-brands fa-linkedin-in" /></a></li>
                          <li><a><i className="fa-brands fa-x-twitter" /></a></li>
                          <li><a><i className="fa-brands fa-youtube" /></a></li>
                          <li><a><i className="fa-brands fa-instagram" /></a></li>
                        </ul>
                      </div>
                    </div>
                    <div className="team-content-area">
                      <div className="heading2">
                        <h4>{item.name}</h4>
                        <p className="mt-2">{item.role}</p>
                      </div>
                      <div className="plue-icon">
                        <button><i className="fa-solid fa-plus" /></button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
 
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
 
export default Team;
 